export default __webpack_public_path__ + "media/CopilotForSecurity.a8c0e624.svg";